import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { NewRelicService } from "./domain/payment-domain/services/newRelic.service";
import { LoaderSubjectService } from "./shared/ui-commons/ui-spinner/util-commons/service/loader-subject.service";
import { Observable, Subscription } from "rxjs";
import { RouterOutlet, Router } from "@angular/router";
import { SpinerContainerComponent } from "./shared/ui-commons/ui-spinner/container.component";
import { environment } from "../environments/environment";
import { CookiesDetectionService } from "./domain/payment-domain/services/cookies-detection-service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterOutlet, SpinerContainerComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  private newRelicService = inject(NewRelicService);

  private readonly lss = inject(LoaderSubjectService);

  private cookieDetectionService = inject(CookiesDetectionService);
  private router = inject(Router);

  constructor() {
    this.isLoading$ = this.lss.isLoading$;
  }

  private loaderSubscriptionRef = new Subscription();

  showLoader = false;

  ngOnInit(): void {
    /*const cookiesEnabled = this.cookieDetectionService.areCookiesEnabled();
    if (!cookiesEnabled) {
      this.newRelicService.addPageAction("BLOCKED-COOKIE", {
        component: "AppComponent",
        action: "error-cookie",
        detail: "initial-app-blocked-cookie",
        timestamp: new Date().toISOString(),
      });
      this.router.navigate(["/error"]);
    }*/

    this.loaderSubscription();

    const status = this.newRelicService.getStatus();
    console.log("🔍 New Relic Status:", status);

    if (status.available) {
      // Configurar atributos iniciales
      this.newRelicService.addCustomAttribute("appName", "rohan-avi-payments");
      this.newRelicService.addCustomAttribute(
        "environment",
        environment.production ? "production" : "development"
      );
      this.newRelicService.addCustomAttribute(
        "loadTime",
        new Date().toISOString()
      );

      // Ejemplo: rastrear que la app se inicializó
      this.newRelicService.addPageAction("APP_INITIALIZED", {
        component: "AppComponent",
        timestamp: new Date().toISOString(),
      });
    }
  }

  ngOnDestroy(): void {
    this.loaderSubscriptionRef.unsubscribe();
  }

  private loaderSubscription() {
    this.loaderSubscriptionRef = this.lss.isLoading$.subscribe((state) => {
      this.showLoader = state;
    });
  }
}
